export default __webpack_public_path__ + "assets/87e177a32bfc94a26099f66ab19fddb3.svg";